export const STATUS_OPEN = 'Open';
export const STATUS_RESOLVED = 'Resolved';
export const STATUS_CLOSED = 'Closed';
export const STATUS_SEQ_ID = 1;

export const STATUS_OPEN_ID = 1;
export const STATUS_INPROGRESS_ID = 2;
export const STATUS_ON_HOLD_ID = 3;
export const STATUS_RESOLVED_ID = 4;
export const STATUS_CLOSED_ID = 5;
export const STATUS_RE_OPEN_ID = 6;

export const STATUS_ACTIVE = 'active';
export const STATUS_INACTIVE = 'inactive';

export const SEQ_ONE = 1;
export const SEQ_TWO = 2;
export const SEQ_THREE = 3;


export const MINUTE = 'minute';
export const HOUR = 'hour';
export const DAY = 'day';
export const MONTH = 'month';

export const MERGED = 'MERGED';

export const VERY_DISSATISFIED = 1;
export const DISSATISFIED = 2;
export const NEUTRAL = 3;
export const SATISFIED = 4;
export const VERY_SATISFIED = 5;

export const BUSINESS_HOURS_ID = 1;
export const CALENDER_HOURS_ID = 2;

export const BUSINESS_HOURS = "BUSINESS";
export const CALENDER_HOURS = "CALENDER";